import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        errorCodes: [500]
    });

    const updateTicket = (ticketId, payload) => {
        let url = `tickets/${ticketId}`
        return api.put(url, payload);
    }

    const getTicketStatusReasons = (ticketType) => api.get(`tickets/reasons/${ticketType}`);

    // Return back a collection of functions
    return {
        updateTicket, getTicketStatusReasons
    }
}

// let's return back our create method as the default.
export default {
    create
}
